import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { FilterCelebrities } from './FilterCelebrities';

/**
 * @description Примеры использования компонента FilterCelebrities
 */
export const FilterCelebritiesExamples: FC = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="text-white mb-4">Базовый пример</h3>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>{t0}<FilterCelebrities celebrities={[]} onCelebritiesChange={_temp} setCelebrityName={_temp2} onCelebritySelect={_temp3} /></div>;
    t2 = <h3 className="text-white mb-4">С выбранной знаменитостью</h3>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>{t2}<FilterCelebrities celebrities={[1]} celebrityName="John Doe" onCelebritiesChange={_temp4} setCelebrityName={_temp5} onCelebritySelect={_temp6} /></div>;
    t4 = <h3 className="text-white mb-4">С сортировкой</h3>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-8 p-8 bg-[#1A1B1F]">{t1}{t3}<div>{t4}<FilterCelebrities celebrities={[]} sortByName="asc" setSortByName={_temp7} onCelebritiesChange={_temp8} /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
function _temp(ids) {
  return console.log("Celebrities:", ids);
}
function _temp2(v) {
  return console.log("Name:", v);
}
function _temp3(o) {
  return console.log("Selected:", o);
}
function _temp4(ids_0) {
  return console.log("Celebrities:", ids_0);
}
function _temp5(v_0) {
  return console.log("Name:", v_0);
}
function _temp6(o_0) {
  return console.log("Selected:", o_0);
}
function _temp7(v_1) {
  return console.log("Sort:", v_1);
}
function _temp8() {}